module.exports = __webpack_public_path__ + "static/media/rugby.feac2b13.jpg";